export const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 0, g: 0, b: 0 }
}

export const getColorWithOpacity = (hex: string, opacity: number): string => {
  const rgb = hexToRgb(hex)
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`
}

export const getPriorityColorIntensity = (priority: number): number => {
  // 優先度1-5を透明度0.1-1.0にマッピング（より極端に）
  switch (priority) {
    case 1: return 0.1
    case 2: return 0.3
    case 3: return 0.5
    case 4: return 0.75
    case 5: return 1.0
    default: return 0.5
  }
}

